import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export type TerminateModalProps = {
  product: any;
  onTerminate: (reason: string) => void;
  onCancel: () => void;
}

@Component({
  selector: 'app-terminate-modal',
  templateUrl: './terminate-modal.component.html',
  styleUrls: ['./terminate-modal.component.scss']
})
export class TerminateModalComponent {

  terminationReason = new FormControl('', [ Validators.required, Validators.pattern(/\S{4,}/) ]);

  props: TerminateModalProps;

  constructor(private modal: NgbActiveModal) { }

  setDialogProps(props: TerminateModalProps): void {
    this.props = props;
  }

  onTerminate(): void {
    if (this.terminationReason.invalid) {
      return;
    }

    this.props.onTerminate(this.terminationReason.value.trim());
  }

  onCancel(): void {
    this.modal.close();
  }

}
